import styled from '@emotion/styled';

interface BackdropProps {
  onClickClose?: () => void;
  deep?: boolean;
  children?: React.ReactNode;
}

export function Backdrop({ onClickClose, deep, children }: BackdropProps) {
  return (
    <BackdropStyle onClick={onClickClose} deep={Boolean(deep)}>
      {children}
    </BackdropStyle>
  );
}

const BackdropStyle = styled.div<{ deep: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  z-index: 1000;

  ${(props) => props.deep && `background-color: rgba(0, 0, 0, 0.25); z-index: 1001;`}
`;
